import { setCompanyTimeZone } from 'src/components/common/helpers/formatting/time-formatter/timeFormatter'
import { IClockinHistory, ClockinHistory } from '@loadedhub/core-api-sdk'

export { ClockinHistory, type IClockinHistory }

export const transformClockinHistoryOnGet = (
  clockinHistory: IClockinHistory
): IClockinHistory => {
  return {
    ...clockinHistory,
    datestampUpdated: clockinHistory.datestampUpdated
      ? setCompanyTimeZone(clockinHistory.datestampUpdated)
      : undefined,
    clockinTime: setCompanyTimeZone(clockinHistory.clockinTime),
    clockoutTime: clockinHistory.clockoutTime
      ? setCompanyTimeZone(clockinHistory.clockoutTime)
      : undefined,
  }
}
